/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramProductsUserControllerBanReasonsViewedMutationResponse,
  TelegramProductsUserControllerBanReasonsViewedPathParams,
  TelegramProductsUserControllerBanReasonsViewed401,
} from '../../types/TelegramProductsUserControllerBanReasonsViewed.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { telegramProductsUserBanReasonsViewed } from '../../methods/telegramProductsUserBanReasonsViewed.ts';
import { useMutation } from '@tanstack/react-query';

export const telegramProductsUserBanReasonsViewedMutationKey = () =>
  [{ url: '/api/user/telegram/products/ban-reasons-viewed/:id' }] as const;

export type TelegramProductsUserBanReasonsViewedMutationKey = ReturnType<
  typeof telegramProductsUserBanReasonsViewedMutationKey
>;

/**
 * {@link /api/user/telegram/products/ban-reasons-viewed/:id}
 */
export function useTelegramProductsUserBanReasonsViewed<TContext>(
  options: {
    mutation?: UseMutationOptions<
      TelegramProductsUserControllerBanReasonsViewedMutationResponse,
      ResponseErrorConfig<TelegramProductsUserControllerBanReasonsViewed401>,
      { id: TelegramProductsUserControllerBanReasonsViewedPathParams['id'] },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? telegramProductsUserBanReasonsViewedMutationKey();

  return useMutation<
    TelegramProductsUserControllerBanReasonsViewedMutationResponse,
    ResponseErrorConfig<TelegramProductsUserControllerBanReasonsViewed401>,
    { id: TelegramProductsUserControllerBanReasonsViewedPathParams['id'] },
    TContext
  >(
    {
      mutationFn: async ({ id }) => {
        return telegramProductsUserBanReasonsViewed(id, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
